import { useState, useEffect } from "react";
import SectionTitle from "./common/SectionTitle";
import { TESTIMONIALS } from "../constants/data";

export default function Testimonials() {
  const [activeTesti, setActiveTesti] = useState(0);

  useEffect(() => {
    const timer = setInterval(
      () => setActiveTesti((prev) => (prev + 1) % TESTIMONIALS.length),
      5000
    );
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      id="testimonials"
      style={{
        padding: "80px 20px",
        background: "linear-gradient(135deg,#0f2d6b,#1d4ed8)",
      }}
    >
      <div style={{ maxWidth: 860, margin: "0 auto", textAlign: "center" }}>
        <SectionTitle
          tag="Patient Stories"
          title="What Our Patients Say"
          sub="Real experiences from patients and colleagues who trust Dr. Modi's care"
          light={true}
        />

        <div
          style={{
            background: "rgba(255,255,255,0.08)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.15)",
            borderRadius: 28,
            padding: "48px 40px",
            minHeight: 200,
          }}
        >
          <div
            style={{
              fontSize: 64,
              color: "rgba(255,255,255,0.15)",
              lineHeight: 1,
              marginBottom: 12,
              fontFamily: "Georgia",
            }}
          >
            "
          </div>
          <p
            style={{
              color: "white",
              fontSize: 17,
              lineHeight: 1.8,
              fontStyle: "italic",
              marginBottom: 20,
            }}
          >
            {TESTIMONIALS[activeTesti].text}
          </p>
          <div style={{ color: "#fbbf24", fontSize: 20, marginBottom: 10 }}>
            {"★".repeat(TESTIMONIALS[activeTesti].stars)}
          </div>
          <p style={{ color: "#5eead4", fontWeight: 700, fontSize: 15 }}>
            {TESTIMONIALS[activeTesti].name}
          </p>
          <p style={{ color: "#bfdbfe", fontSize: 13 }}>
            {TESTIMONIALS[activeTesti].role}
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 8,
            marginTop: 24,
          }}
        >
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              onClick={() => setActiveTesti(i)}
              style={{
                border: "none",
                cursor: "pointer",
                borderRadius: 50,
                transition: "all 0.3s",
                height: 10,
                background:
                  i === activeTesti ? "#34d399" : "rgba(255,255,255,0.3)",
                width: i === activeTesti ? 30 : 10,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
